<div class="flex flex-col justify-center items-center text-center mb-20  mt-5 md:mt-10">

    <fa-icon [icon]="faHeartBroken" class="text-[250px] text-blue-200"></fa-icon>

    <p class="font-noto-serif text-3xl text-[var(--dark-teal)]">Oops! This auction page isn’t ready</p>
    <p class="text-xl text-[var(--charcoal)] ">It might not exist, or the auction hasn’t opened yet.</p>


    <div class="flex  flex-col md:flex-row items-center gap-4 mt-4 w-full md:w-auto px-4">

        <button pButton type="button" severity="info" class="w-full md:w-[218px] h-[35px]" label="Back to Home"
            [routerLink]="['/']">
        </button>

        <button pButton type="button" severity="info" outlined class="w-full md:w-auto h-[35px]"
            label="Browse Active Auctions" [routerLink]="['/auction-listing']">
        </button>


    </div>


</div>